import React from "react";
const AppContext = React.createContext({
    isLoading: false,
    globalData:null,
    handleLoading:(value:boolean)=>{},
    handleGlobalData:(value:any)=>{},

});
export default AppContext;